<template>
    <div class="content">
      <base-header class="pb-6" :class="AppStyle.GRADIENT_STYLE">
        <b-row align-v="center" class="py-4">
          <b-col cols="7" lg="6">
            <h6 :class="AppStyle.BREADCRUMB_H_STYLE" class="h2 d-inline-block mb-0">Art Books</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-bread-crumb></route-bread-crumb>
            </nav>
          </b-col>
        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
          <card
            class="no-border-card"
            body-classes="px-0 pb-1"
            footer-classes="pb-2"
          >
            <template slot="header">
              <h3 class="mb-0">PhotoBooks</h3>
              <p class="text-sm mb-0">
                Find your photobooks here
              </p>
            </template>
            <div>
              <b-col
                cols="12"
                class="d-flex justify-content-center justify-content-sm-between flex-wrap"
              >
                <el-select
                  class="select-primary pagination-select"
                  v-model="pagination.perPage"
                  placeholder="per Page"
                  @change="handlePageSizeChange"
                >
                  <el-option
                    class="select-primary"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
  
                <div>
                  <base-input
                    v-model="searchQuery"
                    prepend-icon="fas fa-search"
                    placeholder="search..."
                    @keyup="searchPhotoBooks"
                  >
                  </base-input>
                </div>
              </b-col>
  
              <div class="loader" v-if="loading"></div>
  
              <el-table
                class="table-responsive align-items-center table-flush table-striped"
                header-row-class-name="thead-light"
                :data="photobooks"
                v-if="photobooks.length > 0"
              >
                <el-table-column
                  label="Status"
                  min-width="120px"
                  prop="email"
                  sortable
                >
                </el-table-column>
                <el-table-column
                  label="Firstname"
                  min-width="200px"
                  prop="firstname"
                  sortable
                >
                </el-table-column>
  
                <el-table-column label="Art" min-width="100px" sortable>
                  <div slot-scope="{ $index, row }" class="d-flex">
                    {{ photobooks[$index].created_at }}
                  </div>
                </el-table-column>
  
                <el-table-column
                  label="GA"
                  min-width="100px"
                  prop="firstname"
                  sortable
                >
                </el-table-column>
  
                <el-table-column
                  label="RWG"
                  min-width="100px"
                  prop="firstname"
                  sortable
                >
                </el-table-column>
  
                <el-table-column
                  label="Adresse"
                  min-width="200px"
                  prop="firstname"
                  sortable
                >
                </el-table-column>
  
                <el-table-column
                  label="AKZ"
                  min-width="120px"
                  prop="firstname"
                  sortable
                >
                </el-table-column>
  
                <el-table-column
                  label="Erstellt"
                  min-width="140px"
                  prop="created_at"
                  sortable
                >
                </el-table-column>
                <el-table-column min-width="180px" align="right" label="Optionen">
                  <div slot-scope="{ $index, row }" class="d-flex">
                    <a
                      href="#"
                      :class="AppStyle.BUTTON_STYLE"
                      class="btn btn-sm"
                      @click="showPhotoBook(photobooks[$index].id)"
                      ><i class="fas fa-desktop"></i
                    ></a>
                  </div>
                </el-table-column>
              </el-table>
            </div>
  
            <b-card-footer class="py-4 d-flex justify-content-end">

              <base-pagination
                class="pagination-no-border"
                :current="page"
                :per-page="pageSize"
                :total="count"
                @change="handlePageChange($event)"
              >
              </base-pagination>
            </b-card-footer>
          </card>
        </div>
      </b-container>
    </div>
  </template>
  <script>
  import {
    Table,
    TableColumn,
    Select,
    Option,
    DropdownMenu,
    DropdownItem,
    Dropdown,
  } from "element-ui";
  import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
  import { BasePagination } from "@/components";
  import LightTable from "../Tables/RegularTables/LightTable";
  import { TablePlugin } from "bootstrap-vue";
  import moment from "moment";
  
  import AppStyle from '@/plugins/appStyle';
  
  export default {
    mixins: [AppStyle.Mixin],
    components: {
      BasePagination,
      RouteBreadCrumb,
      LightTable,
      [Select.name]: Select,
      [Option.name]: Option,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
    },
    data() {
      return {
        loading: false,
        photobooks: [],
        count: 0,
        page: 1,
        pageSize: 10,
        pageCount: 0,
        pagination: {
          perPage: 10,
          currentPage: 1,
          perPageOptions: [5, 10, 25, 50],
          total: 0,
        },
        searchQuery: "",
        searchedData: [],
      };
    },
    methods: {
      writtenDamageType(data) {
        if (data) {
          return "RTE";
        } else {
          return "Vor-Ort";
        }
      },
      getRequestParams(searchTitle, page, pageSize) {
        let params = {};
  
        if (searchTitle) {
          params["search"] = searchTitle;
        }
  
        if (page) {
          params["page"] = page;
        }
  
        if (pageSize) {
          params["per_page"] = pageSize;
        }
  
        return params;
      },
      retrievePhotoBooks() {
        const params = this.getRequestParams(
          this.searchTitle,
          this.page,
          this.pageSize
        );
        this.loading = true;
        this.$api
          .getPhotoBooks(params)
          .then((response) => {
            const { photobooks, count, page, page_count } = response.data;
            console.log(response.data);
            this.photobooks = response.data.photobooks;
            this.page = response.data.page;
            this.pageCount = response.data.page_count;
            this.count = response.data.count;
            this.pagination.total = response.data.count;
            console.log(response.data);
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      searchPhotoBooks() {
        const params = this.getRequestParams(
          this.searchQuery,
          this.page,
          this.pageSize
        );
        this.loading = true;
        this.$api
          .searchPhotoBooks(params)
          .then((response) => {
            const { photobooks, page, page_count, count } = response.data;
            this.photobooks = photobooks;
            (this.page = page), (this.pageCount = page_count);
            this.count = count;
  
            //console.log(response.data);
          })
          .catch((e) => {
            console.log(e);
          })
          .finally(() => {
            this.loading = false;
          });
      },
  
      handlePageChange(value) {
        this.page = value;
        this.retrievePhotoBooks();
      },
  
      handlePageSizeChange(value) {
        this.pageSize = value;
        this.page = 1;
        this.retrievePhotoBooks();
      },
      formatDate(date) {
        return moment(date).format("DD.MM.YYYY h:mm");
      },
      showPhotoBook(photobookId) {
        //this.$router.push({ path: `/photobooks/${this.photobook.token}` })
        //this.$router.push({ path: `/photobooks/${photobookId}` })
        //this.$router.push({ path: `/photobooks/${photobookId}`, query: { tab: 'Dokumente' } })
        this.$router.push({
          name: "Schaden anzeigen",
          params: { token: `${photobookId}`, tab: "Dokumente" },
        });
      },
    },
    computed: {
      searchRegExp() {
        return new RegExp(`(.*)${this.search}(.*)`);
      },
      rows() {
        return this.photobooks.length;
      },
    },
    created() {
      this.retrievePhotoBooks();
    },
  };
  </script>
  <style scoped>
  #axiosForm {
    /* Components Root Element ID */
    position: relative;
  }
  .loader {
    /* Loader Div Class */
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url(/img/custom/ajax-loader.gif);
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.4;
    filter: alpha(opacity=40);
  }
  </style>